import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { drcallimg } from "../Constant/Index";

const PhotoAnimation = ({ src ,getapi}) => {
	const photoRef = useRef(null);
	const imgRef = useRef(null);
	const glowRef = useRef(null);

	useEffect(() => {
		const photo = photoRef.current;
		const img = imgRef.current;
		const glow = glowRef.current;

		const handleMouseEnter = () => {
			gsap.to(img, {
				duration: 1,
				scale: 1.1,
				rotation: 5,
				filter: "grayscale(0%) contrast(150%)",
				boxShadow: "20px 20px 30px rgba(0, 0, 0, 0.5)",
				ease: "power2.out",
			});

			gsap.to(glow, {
				duration: 1,
				x: "450%",
				background: "rgba(255, 255, 255, 0.4)",
				ease: "power2.out",
			});
		};

		const handleMouseLeave = () => {
			gsap.to(img, {
				duration: 1,
				scale: 1,
				rotation: 0,
				filter: "grayscale(100%) contrast(120%)",
				boxShadow: "10px 15px 25px rgba(0, 0, 0, 0.2)",
				ease: "power2.out",
			});

			gsap.to(glow, {
				duration: 1,
				x: "-450%",
				background: "rgba(255, 255, 255, 0.2)",
				ease: "power2.out",
			});
		};

		photo.addEventListener("mouseenter", handleMouseEnter);
		photo.addEventListener("mouseleave", handleMouseLeave);

		return () => {
			photo.removeEventListener("mouseenter", handleMouseEnter);
			photo.removeEventListener("mouseleave", handleMouseLeave);
		};
	}, []);
	return (
		<a href="#" className="photo" ref={photoRef}>
			<img src={getapi?.sectionOne?.image} className="img-fluid" ref={imgRef} />
			<div className="glow-wrap">
				<i className="glow" ref={glowRef}></i>
			</div>
		</a>
	);
};

export default PhotoAnimation;
